
import * as angular from "angular";
import { CanvasService } from "./canvas.service";

export class AvatarService {

    //private colours = [
    //    "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
    //    "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"
    //];

    // If we only pick one we should pick "#757D75"
    //private greyColours = ["#757D75", "#6c7a89", /*"#bdc3c7",*/ "#95a5a6", /*"#dadfe1",*/ /*"#abb7b7", "#bfbfbf"*/];
    //private greyColours = ["#757D75", "#6c7a89", "rgb(107,107,107)", "rgb(125,125,125)", "rgb(135,135,135)", "rgb(73,73,73)", "rgb(91,91,91)", "rgb(106,106,106)", "rgb(113,113,113)", "rgb(105,105,105)", "rgb(134,134,134)"];
    //private greyColours = ["rgb(125,125,125)"];
    private greyColours = ["rgb(135,135,135)"];

    private avatarCache: string[] = [];

    static $inject = ["$q", "canvasService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly canvasService: CanvasService) {
    }

    getAvatar(name: string, singleLetter = false, size = 60): angular.IPromise<string> {
        var defer = this.$q.defer<string>();

        const nameSplit = name.toUpperCase().replace(/[^\w\s]/gi, '').split(' ');
        var initials = "";

        if (nameSplit.length == 1 || singleLetter) {
            initials = nameSplit[0] ? nameSplit[0].charAt(0) : "?";
        }
        else {
            initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }

        const cacheKey = `${initials}-${size}`;

        if (this.avatarCache[cacheKey]) {
            defer.resolve(this.avatarCache[cacheKey]);
            return defer.promise;
        }

        var charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
        var colourIndex = charIndex % this.greyColours.length;

        var canvas = this.canvasService.getSingleUseCanvas(size, size);
        var context = canvas.getContext("2d");

        context.fillStyle = this.greyColours[colourIndex];
        context.fillRect(0, 0, size, size);
        context.font = Math.ceil(size / 2) + "px Roboto";
        context.textAlign = "center";
        context.fillStyle = "#FFF";
        context.fillText(initials, size / 2, size / 1.5);

        var dataURI: string;

        canvas.toBlob(blob => {
            dataURI = URL.createObjectURL(blob);
            this.avatarCache[cacheKey] = dataURI;

            defer.resolve(this.avatarCache[cacheKey]);
        });

        return defer.promise;
    }
}
